import { render } from "./ReportCriterionSelect.vue?vue&type=template&id=74d5baa9&scoped=true"
import script from "./ReportCriterionSelect.vue?vue&type=script&lang=js"
export * from "./ReportCriterionSelect.vue?vue&type=script&lang=js"

import "./ReportCriterionSelect.vue?vue&type=style&index=0&id=74d5baa9&lang=scss&scoped=true"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d5baa9"]])

export default __exports__